import { Link } from "react-router-dom";

const POS_ORDER = { GK: 0, DEF: 1, MID: 2, FWD: 3 };
const POS_LABEL = { GK: "Goalkeeper", DEF: "Defender", MID: "Midfielder", FWD: "Forward" };

export const sortSquad = (players) =>
  [...players].sort((a, b) =>
    (POS_ORDER[a.position] ?? 9) - (POS_ORDER[b.position] ?? 9)
    || (a.number ?? 999) - (b.number ?? 999)
    || (a.name || "").localeCompare(b.name || ""));

// Compact squad list: # · Name · Position · ABFA ID
export const SquadTable = ({ players, testId }) => (
  <table className="w-full text-sm" data-testid={testId}>
    <thead>
      <tr className="text-[10px] uppercase tracking-widest text-gray-400 border-b border-gray-200">
        <th className="text-left py-2 pl-4 w-12">#</th>
        <th className="text-left py-2">Player</th>
        <th className="text-left py-2 hidden sm:table-cell w-36">Position</th>
        <th className="text-left py-2 pr-4 hidden md:table-cell w-44">ABFA ID</th>
      </tr>
    </thead>
    <tbody>
      {sortSquad(players).map((p) => (
        <tr key={p.player_id} className="border-b border-gray-100 last:border-0 hover:bg-[#FFC72C]/10 transition-colors" data-testid={`squad-row-${p.player_id}`}>
          <td className="py-2.5 pl-4 font-heading font-bold text-gray-400">{p.number ?? "–"}</td>
          <td className="py-2.5">
            <Link to={`/players/${p.player_id}`} className="font-semibold text-[#09090b] hover:text-[#009E60] transition-colors" data-testid={`squad-player-link-${p.player_id}`}>
              {p.name}
            </Link>
            <span className="sm:hidden ml-2 text-[10px] font-bold text-gray-400">{p.position}</span>
          </td>
          <td className="py-2.5 hidden sm:table-cell text-gray-600">{POS_LABEL[p.position] || p.position || "–"}</td>
          <td className="py-2.5 pr-4 hidden md:table-cell font-mono text-xs text-gray-500">{p.registration_id || "–"}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
